import { render, staticRenderFns } from "./ObiCard.vue?vue&type=template&id=035c067f&scoped=true&"
import script from "./ObiCard.vue?vue&type=script&lang=js&"
export * from "./ObiCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiCard.vue?vue&type=style&index=0&id=035c067f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c067f",
  null
  
)

export default component.exports